import React from "react";
import {
    Letter, OuterNameWrapper,
} from "./ResultCard.styles";
import {Link} from "BaseComponents/Link";

export const ResultNamedCard = ({marker}) => {
    return <>
        <Letter width="100%">{marker.letter}</Letter>
        <OuterNameWrapper>
            {marker?.markers.map((c, index) => {
                const prefix = index === marker?.markers.length - 1 ? "" : ',';
                return <Link key={index} text={`${c.Name}${prefix}`} href={c.Url}/>
            })}
        </OuterNameWrapper>
    </>
};
